export default __webpack_public_path__ + "static/media/logo-Adrian.aef6d51e.png";